document.addEventListener("DOMContentLoaded", function() {
        
        document.addEventListener("ReelUpProductLoaded", function(e) {
          let __product = e.detail.productJSON;
          let __productSelector = e.detail.productSelector;
          let __productDescription = __productSelector.querySelector('.reelUp_product_description');
          
              if(__productDescription){
                function decodeEntities(encodedString) {
                  // Replace "#" with an empty string
                  encodedString = encodedString.replace(/#/g, '');
                  const textarea = document.createElement('textarea');
                  textarea.innerHTML = encodedString;
                  return textarea.value;
              }   
               let __finalDescription = decodeEntities(__productDescription.innerHTML);
                __productDescription.innerHTML=__finalDescription
            }
        });
      });